import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private stripe: Stripe | null = null;

  constructor() {}

  async initializeStripe(token: string) {
    this.stripe = await loadStripe(token, {
      stripeAccount: 'acct_1Pg9HnRvQpwge4Xm',
    });
  }

  getStripe() {
    return this.stripe;
  }
}
